<template>
  <ProductTitle
    v-bind="{
      productName,
      description,
      pdfEmailDescription,
      brandUrl,
      brandDisplayName,
      productUrl,
      allowOpeningInNewTab,
      ...( showBrandLink ? { brandName } : {} ),
    }"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import ProductTitle from './ProductTitle';

defineProps({
  productUrl: {
    type: String,
    default: '',
  },
  showBrandLink: {
    type: Boolean,
    required: false,
    default: true,
  },
  allowOpeningInNewTab: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const {
  productName,
  brandName,
  brandDisplayName,
  brandUrl: brandUrlRaw,
  secondaryDescription: description,
  pdfEmailDescription,
} = useCommonProductGetters();

const brandUrl = computed(() => brandName.value && brandUrlRaw.value);

defineExpose({ // eslint-disable-line no-undef
  brandName,
  brandUrl,
  productName,
  description,
  pdfEmailDescription,
});
</script>
